import { Address } from "@/services/api/commonTypes";

export const serialiseAddress = (data: Address): string => {
  return `${data.addressLine1 ?? ''}|${data.addressLine2 ?? ''}|${data.townCity ?? ''}|${data.stateCounty ?? ''}|${
    data.postalCode ?? ''
  }|${data.country ?? ''}`;
};

export const deserialiseAddress = (data: string): Address | undefined => {
  if (!data) return;

  const splitAddress = data.split('|');

  if (!splitAddress.length) return;

  return {
    addressLine1: splitAddress[0],
    addressLine2: splitAddress[1],
    townCity: splitAddress[2],
    stateCounty: splitAddress[3],
    postalCode: splitAddress[4],
    country: splitAddress[5]
  };
};